@if(navigationItem$ | async){}

<div class="st-side-menu h-full ">
  <div class="menu-header flex align-items-center gap-2">
    <button class="back-btn" (click)="back()">
      <em class="icon-caret-left"></em>
    </button>
    @if(navigationItem()?.children?.length){
    <div class="body-large-bold">{{navigationItem()?.name}}</div>
    } @else if(tools()?.length){
    <div class="body-large-bold">Tools</div>
    }
  </div>
  @if(navigationItem()?.children?.length){
  <div>
    @for(item of navigationItem()?.children; track $index){
    <st-menu-collapse-item [menuItemData]="item"
      [active]="activeChild() !== null && (activeChild()?.id === item.id)"></st-menu-collapse-item>
    }
  </div>
  }@else if(tools()?.length){
  <div class="flex flex-column gap-1 tools-list">
    @for(tool of tools(); track $index){
    <a class="flex align-items-center gap-2 tools-list-item px-2 py-1" (click)="openTool(tool.publicUrl)">
      <img [src]="tool.iconImageUrl" alt="" width="24" height="24">
      <div class="webkit-box-one-line body-medium-bold">{{tool.name}}</div>
      <em class="icon-arrow-square-out ml-auto"></em>
    </a>
    }
  </div>
  }
</div>